import loadable from '@loadable/component';
import Views from '@fogia/core-web/Views';
import Footer from 'Footer';
import Overlay from 'Overlay';
import Popups from 'Popups';
import NotificationWrapper from 'components/wrappers/NotificationWrapper';
import { HeaderContextProvider } from '@fogia/core-web/contexts/HeaderContext';
// import { Header } from './Header/header';
import { HeaderNavigationContextProvider } from '@fogia/core-web/contexts/HeaderNavigationContext';
import React, { useEffect } from 'react';
import { inServer } from '@fogia/core-web/constants';
import Cookies from 'js-cookie';
import useAppDispatch from '@fogia/core-web/hooks/useAppDispatch';
import getUser from '@fogia/core-web/state/customer/user/getUser';
import { Header } from 'components/Header';
import styled from 'libs/styled';

const PageTransitionOverlay = loadable(() => import('@fogia/core-web/components/PageTransitionOverlay'));

const ViewsWrapper = styled('div')`
    position: relative;
`;

const Site = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const fetchData = async () => {
            if (!inServer && Cookies.get('user_logged_in') === 'true') {
                await dispatch(getUser());
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <Overlay />
            <Popups />
            <PageTransitionOverlay />
            <HeaderContextProvider>
                <HeaderNavigationContextProvider>
                    <Header />
                    <ViewsWrapper id="site-views-wrapper">
                        <Views />
                    </ViewsWrapper>
                </HeaderNavigationContextProvider>
            </HeaderContextProvider>
            <Footer />
            <NotificationWrapper />
        </>
    );
};

export default Site;

export { Site as DefaultSite };
